export default "__VITE_ASSET__CN4j_Pgm__"